/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestData,
  AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestDataFromJSON,
  AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestDataFromJSONTyped,
  AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestDataToJSON
} from './AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestData'

/**
 *
 * @export
 * @interface AuthVisitorUnifiedFormSigninResponseVisitor
 */
export interface AuthVisitorUnifiedFormSigninResponseVisitor {
  /**
   *
   * @type {AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestData}
   * @memberof AuthVisitorUnifiedFormSigninResponseVisitor
   */
  visitorContactRequestData?: AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestData
}

export function AuthVisitorUnifiedFormSigninResponseVisitorFromJSON(
  json: any
): AuthVisitorUnifiedFormSigninResponseVisitor {
  return AuthVisitorUnifiedFormSigninResponseVisitorFromJSONTyped(json, false)
}

export function AuthVisitorUnifiedFormSigninResponseVisitorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AuthVisitorUnifiedFormSigninResponseVisitor {
  if (json === undefined || json === null) {
    return json
  }
  return {
    visitorContactRequestData: !exists(json, 'visitor_contact_request_data')
      ? undefined
      : AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestDataFromJSON(
          json['visitor_contact_request_data']
        )
  }
}

export function AuthVisitorUnifiedFormSigninResponseVisitorToJSON(
  value?: AuthVisitorUnifiedFormSigninResponseVisitor | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    visitor_contact_request_data: AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestDataToJSON(
      value.visitorContactRequestData
    )
  }
}
